<template>
    <section>
        <v-form v-model="valid">
            <span class="subtitle-1 font-weight-bold">Påmelding</span>
            <autocomplete ref="autocomplete" :source="customerSearch" :results-display="formatDisplay" @results="setResults" style="display:none"></autocomplete>
            <v-autocomplete @input="selectResult" :search-input.sync="accountSearch" :items="accountResults" item-value="name" item-text="name" return-object label="Firma" no-data-text="Inget resultat" class="tile" outlined single-line dense attach>
                <template v-slot:item="data">
                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.orgNumber"></v-list-item-subtitle>
                </template>
            </v-autocomplete>
            <v-text-field v-model="account.accountNumber" label="Organiasjonsnummer" class="tile" outlined single-line dense ></v-text-field>
            <v-text-field v-model="address.address" label="Fakturaadresse"  class="required tile" outlined single-line dense :rules="[v => !!v || 'Fakturaadresse er påkrevd!']"></v-text-field>
            <v-text-field v-model="address.post" label="Postnummer"  class="required tile" outlined single-line dense :rules="[v => !!v || 'Postnummer er påkrevd!']"></v-text-field>
            <v-text-field v-model="address.city" label="Poststed"  class="required tile" outlined single-line dense :rules="[v => !!v || 'Poststed er påkrevd!']"></v-text-field>
            <v-text-field v-model="account.invoiceNote" label="Fakturamerknad" class="tile" outlined single-line dense></v-text-field>
            <Participant v-for="(contact, index) in contacts" 
                :number="index+1" 
                :key="index"
                @remove-participant="removeParticipant"/>
            <v-btn tile block outlined color="red" class="add-participant-button" @click="addParticipant">
                <v-icon dark>mdi-plus</v-icon>
            </v-btn>
            <v-space></v-space>
            <p class="title pt-5 mb-0">Pris: {{(selectedCourse.price && selectedCourse.price.match(/\d+/g)[0]) * contacts.length}} kr</p>
            <v-row no-gutters>
                <v-col cols="12" sm="8">
                    <v-checkbox
                    v-model="agreement"
                    :rules="[v => !!v || 'Du må godta for å fortsette!']"
                    label="Jeg godtar betingelsene."
                    required
                    >
                    </v-checkbox>
                </v-col>
                <v-col cols="12" sm="4">
                    <p class="text-right mt-sm-5">Les betingelsene <a @click='showConditions = true'>her</a></p>
                </v-col>
            </v-row>
            <Conditions />  
        </v-form>
        <v-btn v-if="!registeredError"
            block
            tile
            color="red"
            :loading="loading"
            :disabled="!formIsCompleted || loading"
            @click="register"> Meld på
        </v-btn>
        <v-alert v-model="registeredError" dismissible type="error">
            Det oppstod en feil.
        </v-alert>
    </section>
</template>

<script>
/* eslint-disable */
import Api from '../utils/api.js'
import Participant from './Participant.vue'
import Conditions from './Conditions.vue'
import eventHelper from '../mixins/event.js'
import Autocomplete from 'vuejs-auto-complete'
import VueScrollTo from 'vue-scrollto'

export default {
    components: {
        Participant,
        Conditions,
        Autocomplete,
    },
    data: function(){
        return {
            accountSearch: '',
            accountResults: [],
            account: {
                name: null,
                accountNumber: null,
                invoiceNote: null
            },
            address: {
                address: null,
                post: null,
                city: null
            },
            contacts: [{
                firstname: null,
                lastname: null,
                birthdate: null,
                emailaddress1: null
            }],
            loading: false,
            registeredError: false,
            agreement: false,
            showConditions: false
        }
    },
    computed: {
        formIsCompleted(){
            return this.agreement && !(this.objectHasEmptyValue(this.address) || this.contacts.some((contact) => this.objectHasEmptyValue(contact) || Number.isNaN(Date.parse(contact.birthdate))));
        },
    },
    props:['selectedCourse'],
    mixins: [eventHelper],
    methods: {
        async register(){
            this.loading = true;
            this.formatContacts(this.contacts);

            Api.registerToCourse(this.selectedCourse.id, this.account, this.address, this.formatContacts(this.contacts)).then((result) => {
                if (result.data){
                    this.$parent.$parent.selectedOpen = false;
                    this.$parent.$parent.registeredSuccess = true;
                    setTimeout(() => { 
                        if (this.$parent.$parent.mobileAndTabletcheck()){
                            VueScrollTo.scrollTo("#registeredSuccess", 800, { offset: -500 });
                        }
                    }, 10);
                    this.loading = false;
                }
                else {
                    this.registeredError = true;
                    this.loading = false;
                }
            }).catch(() => {
                this.registeredError = true;
                this.loading = false;
            });
        },
        addParticipant(){
            this.contacts.push({ firstname: null, lastname: null, birthdate: null, emailaddress1: null });
        },
        removeParticipant(number){
            this.contacts.splice(number-1, 1);
        },
        objectHasEmptyValue(obj){
            return Object.values(obj).some((el) => (el == null || el.length == 0));
        },
        formatContacts(contacts){
            return contacts.map((contact) => { contact.birthdate = this.formatDate(contact.birthdate); return contact});
        },
        formatDate(date){
            if (date == null)
                return date;
            var separator = date.indexOf('.') > -1 ? '.' : '/';
            var array = date.split(separator).reverse();
            if (array[0].length == 2) {
                var year = parseInt(array[0])
                var currentYearString = new Date().getFullYear().toString();
                var currentYear = parseInt(currentYearString.substring(2));
                var currentCentury = parseInt(currentYearString.substring(0,2)) * 100;
                array[0] = (year + ((year < currentYear) ? currentCentury : (currentCentury - 100))).toString()
            }
            return array.join('-');
        },
        customerSearch(input) {
            return Api.getSearchEndpoint() + '?q=' + input
        },
        selectResult(result) {
            this.account.name = result.name
            this.account.accountNumber = result.orgNumber
            this.address.address = result.address
            this.address.post = result.post
            this.address.city = result.city
            this.accountSearch = result.name
        },
        formatDisplay(result) {
            return result.name
        },
        setResults(results) {
            this.accountResults = results.results;
        },
    },
    watch: {
        selectedCourse: function () {
            this.$parent.$parent.registeredSuccess = false;
            this.registeredError = false;
        },
        accountSearch: function(newValue) {
            this.$refs.autocomplete.display = newValue;
            this.$refs.autocomplete.search();
        }
    }
}
</script>
<style>
.required label::before {
    content: "* ";
    color: red;
}

.v-text-field.tile {
    border-radius: 0;
}

.v-text-field.tile .v-input__slot {
    background-color: #fff;
}

.add-participant-button {
    background-color: #fff;
}
</style>